export function formatEur(cents: number | null | undefined): string {
  if (cents == null) return '—';
  return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}

/**
 * Formatea una hora de evento ("HH:MM" o "HH:MM:SS" en UTC, o un ISO completo)
 * en la zona horaria LOCAL del ordenador del usuario.
 *
 * Los eventos de calendario se guardan en BD como `time` en UTC (el sync de
 * Outlook hace `toISOString().slice(11,19)`), por lo que una hora "suelta"
 * se interpreta como UTC y se desplaza a la zona local del navegador. No se
 * fija ningún `timeZone` a propósito: usamos la del ordenador.
 */
export function formatEventTime(value: string | null | undefined): string {
  if (!value) return '—';
  // #268 · el sync de Outlook guarda la hora de PARED en Europe/Madrid ("HH:MM[:SS]", sin zona).
  // Hay que mostrarla TAL CUAL, sin reinterpretarla como UTC (antes se le añadía 'Z' y se
  // convertía a local, lo que sumaba el desfase horario → reuniones adelantadas 1-2 h).
  if (/^\d{2}:\d{2}/.test(value)) return value.slice(0, 5);
  // ISO completo con zona (lleva 'T' + offset/Z) → convertir a Europe/Madrid.
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value.slice(0, 5);
  return d.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Madrid',
  });
}

/** Fecha + hora local (p.ej. "12 jun 2026, 14:30") · #187 sellos del cronómetro de tareas. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Minutos → "Xh Ym" legible · #187 totales de tiempo de tareas. */
export function formatMinutesAsHours(minutes: number | null | undefined): string {
  if (minutes == null || minutes <= 0) return '0 h';
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  if (h === 0) return `${m} min`;
  if (m === 0) return `${h} h`;
  return `${h} h ${m} min`;
}

export function statusLabel(status: string): string {
  const labels: Record<string, string> = {
    draft: 'Borrador',
    ready_to_issue: 'Lista para emitir',
    issued: 'Emitida',
    sent: 'Enviada',
    paid: 'Cobrada',
    overdue: 'Vencida',
    cancelled: 'Anulada',
  };
  return labels[status] ?? status;
}
